import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

import LooksSelector from "areas/collection/looks-selector"
import ProductDescription from "areas/collection/products/product-description"
import ProductPrice from "areas/collection/products/product-price"

import ProductImage from "./product-image"

const setDefaultLook = (product) => {
  if (!product.looks) return ""
  return product.looks && product.default_look
    ? product.default_look
    : Object.keys(product.looks)[0]
}

const ProductCard = ({ element, handleClick, imageSizes, index, product }) => {
  const [selectedLook, setSelectedLook] = useState(setDefaultLook(product))

  const selectedProductLook = product.looks ? product.looks[selectedLook] : null

  if (!selectedProductLook) {
    // Prevents selectedLook from being undefined and breaking the component on reload of products. Gives useEffect a chance to update.
    return null
  }

  const onItemClick = () => {
    handleClick(product.title || product.name, selectedProductLook.product_url)
  }

  useEffect(() => {
    // Update selected metal when default_look is changed
    setSelectedLook(setDefaultLook(product))
  }, [product])

  return (
    <div>
      <Link
        className="relative mb-8 block"
        data-lc={element.anchor_name || element.id}
        onClick={onItemClick}
        to={selectedProductLook.product_url}
      >
        <ProductImage
          alt={selectedProductLook.alt || product.name}
          images={selectedProductLook.images}
          index={index}
          sizes={
            imageSizes ||
            "(max-width: 767px) 50vw, (max-width: 1023px) 23vw, (max-width: 1920px) calc((100vw - 320px) / 4.5), 322px"
          }
          styleCode={product.style_code}
          type={product.product_type}
        />
      </Link>
      <LooksSelector
        className="desktop:pt-12 desktop:pb-16 justify-start py-6"
        looks={product.looks}
        product={product}
        selectedLook={selectedLook}
        updateLook={(look) => setSelectedLook(look)}
      />
      <ProductDescription productName={product.title || product.name} />
      {selectedProductLook.selling && (
        <ProductPrice
          product={{
            ...selectedProductLook,
            style_code: product.style_code,
          }}
        />
      )}
      {product.hasDiamond && (
        <p className="text-13 desktop:text-16 italic">{product.hasDiamond}</p>
      )}
    </div>
  )
}

ProductCard.propTypes = {
  element: PropTypes.object,
  handleClick: PropTypes.func,
  imageSizes: PropTypes.string,
  index: PropTypes.number,
  product: PropTypes.object,
}

export default ProductCard
